import React from "react";
import styles from "./index.module.scss";
import { Icon } from "antd";

interface PhotoItemProps {
    url: string;
    time: string;
    onClick?: () => void;
}

export default function PhotoItem({ url, time, onClick }: PhotoItemProps) {
    return (
        <div className={styles.root} role="button" onClick={onClick}>
            <div className={styles.photo}>
                <img src={url} />
            </div>

            <div className={styles.footer}>
                {time} <Icon type="zoom-in" />
            </div>
        </div>
    );
}
